module.exports = __webpack_public_path__ + "img/search_camera.9214cab7.svg";